import { Effect } from '../event/effect';

import { EWSEventType } from '../types/socket'
import type { IInitParams, EWSEventName } from '../types/socket';

class DeviceWebSocket extends Effect {
  ws: WebSocket | null = null;
  url: string = '';

  setParams (params: IInitParams) {
    this.url = params.url;
    return this;
  }

  connect () {
    return new Promise<WebSocket | null>((resolve, reject) => {
      this.ws = new WebSocket(this.url);
      this.ws.binaryType = 'arraybuffer';
      this.ws.onopen = () => {
        resolve(this.ws);
        if (this.ws) {
          this.ws.onmessage = (ev: MessageEvent) => {
            const response = JSON.parse(ev.data);
            this.hookEvent(response.eventName, response)
          }
          this.ws.onerror = reject;
        }
      }
    })
  }

  send<T> (eventName: EWSEventName, data: T) {
    this.ws?.send(JSON.stringify({ eventType: EWSEventType.CLIENT, eventName, data }));
  }

  close () {
    this.ws?.close();
  }
}

export function deviceWebSocket () {
  const instance = new DeviceWebSocket();
  return {
    getWSInstance: () => instance.ws,
    close: instance.close.bind(instance),
    send: instance.send.bind(instance),
    setParams: instance.setParams.bind(instance),
    connect: instance.connect.bind(instance),
    effect: instance.effect.bind(instance)
  }
}
